export default {"src":"/_next/static/media/invalidation.14dae875.svg","height":167,"width":238,"blurWidth":0,"blurHeight":0};